const CONTRACTS_FIELDS_MAPPER = {
  id: { label: 'ID', key: 'id' },
  subscriptionId: { label: 'Subscription ID', key: 'subscriptionId' },
  name: { label: 'Name', key: 'name' },
  status: {
    label: 'Status',
    key: 'status',
    options: [
      { text: 'Draft', value: 'draft' },
      { text: 'Sealed', value: 'sealed' },
      { text: 'Sent', value: 'sent' },
      { text: 'Reviewed', value: 'reviewed' },
      { text: 'Signed', value: 'signed' },
      { text: 'Rejected', value: 'rejected' },
    ],
  },
  subscriptionOwner: { label: 'Subscription Owner', key: 'recipients' },
  templateName: { label: 'Contract Template', key: 'templateName' },
  createdAt: { label: 'Created At', key: 'createdAt' },
};

const INITIAL_CONTRACTS_GRID_COLUMNS = [
  ...Object.values(CONTRACTS_FIELDS_MAPPER)
    .filter((field) => field.key !== CONTRACTS_FIELDS_MAPPER.id.key)
    .map((field) => ({
      ...field,
      value: true,
    })),
];
const CONTRACTS_PAGE_SIZE = 200;
const CONTRACTS_DEFAULT_ORDER = 'desc';
const CONTRACTS_DEFAULT_ORDER_BY = 'createdAt';
const CONTRACTS_DATE_FORMAT = 'dd/MM/yyyy';

const DEFAULT_DROPDOWN_OPTION = {
  text: '-',
  value: undefined,
};

export {
  CONTRACTS_PAGE_SIZE,
  CONTRACTS_DEFAULT_ORDER,
  CONTRACTS_DEFAULT_ORDER_BY,
  CONTRACTS_FIELDS_MAPPER,
  INITIAL_CONTRACTS_GRID_COLUMNS,
  CONTRACTS_DATE_FORMAT,
  DEFAULT_DROPDOWN_OPTION,
};
